import { useEffect, useState } from 'react';
import Menu from '../../../../components/Menu/Menu';
import './Database.scss';
import api from '../../../../js/api';
import { Link, useNavigate } from 'react-router-dom';

export default function Database() {
    const navigate = useNavigate();
    const [data, setData] = useState(null);

    useEffect(() => {
        const fetch_ = async () => {
            try {
                const response = await api.get(`/vehicles`);
                console.log('vehicles: ', response);
                localStorage.setItem('vehicles', JSON.stringify(response));
                setData(response);
            } catch (error) {
                console.error(error);
                setData({ "Error fetching data": "Error fetching data" });
            }
        }
        fetch_();
    }, []);
    return (
        <div id="database">
            <div className='centered-container'>

                <h1>All BEV Cars</h1>
                {data ? (
                    Object.keys(data).sort().map((key, index) => (
                        <p to={`/car/${key}`} key={index} className='car-link' onClick={() => navigate(`${key}`)}>
                            {key}
                        </p>
                    ))
                ) : (
                    <div>
                        Loading...
                    </div>
                )}
                <Menu title="" options={[
                    { name: 'Go Back', path: '/..' },
                ]} />

            </div>
        </div>
    );
}